import { render, staticRenderFns } from "./CaseProcessingPostContent.vue?vue&type=template&id=e36bddf6&scoped=true&"
import script from "./CaseProcessingPostContent.vue?vue&type=script&lang=js&"
export * from "./CaseProcessingPostContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36bddf6",
  null
  
)

export default component.exports